import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ScrollView,
    ActivityIndicator, KeyboardAvoidingView, Platform, RefreshControl
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import {DrawerNavigationProp} from "@react-navigation/drawer";
import ClientItem from "../Components/ClientItem";
import HttpRequest from "../utils/HttpRequest";
import IClient from "../Models/Client/IClient";
import App from "../App";
import AppButton from "../Components/AppButton";
import AlertModal from "../Components/AlertModal";
import {saveClients} from "../Models/Client/ClientActions";
import PrintClientOrdersModal from "../Components/PrintClientOrdersModal";


type navProps = DrawerNavigationProp< any, 'Clients'>;
interface IProps {
    navigation:navProps;
    saveClients:(clients:IClient[])=>AnyAction
}
interface IState {
    isAddOpened:boolean;
    clients:IClient[];
    clientToAdd:IClient;
    showAlert:boolean;
    alertText:string;
    isErrorAlert:boolean;
    loading:boolean;
    filterName:string;
    filterAddress:string;
    isSearching:boolean;
    fetching:boolean;
    showPrintModal:boolean;
    selectedClient?:IClient
}

class Clients extends React.Component<IProps> {

    state:IState={
        isAddOpened:false,
        clients:[],
        clientToAdd:{businessName:'',businessNumber:-1,address:'',contactName:'',phone:'',email:'',isDeleted:false},
        showAlert:false,
        isErrorAlert:false,
        alertText:'',
        loading:false,
        filterName:'',
        filterAddress:'',
        isSearching:false,
        fetching:false,
        showPrintModal:false,

    }
    focusListiner:any=null;
    componentDidMount() {
        this.focusListiner= this.props.navigation.addListener('focus',this.setData)

    }
    setData=()=>{
        this.fetchData()
    }
    componentWillUnmount() {
        if(this.focusListiner){
            this.focusListiner()
        }
    }
    fetchData(){
        this.setState({fetching:true})
        HttpRequest('clients',"GET").then((result)=>{
            this.props.saveClients(result.data)
            this.setState({clients:result.data})

        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    setClientProp<K extends keyof IClient>(value:any,key:K){
        let c=this.state.clientToAdd;
        c[key]=value;
        this.setState({clientToAdd:c})

    }
    addClient(){
      let c=  this.state.clientToAdd;
      if(c.businessName=='' || c.businessNumber==-1 || c.address=='' || c.contactName=='' || c.phone==''){
          this.setState({showAlert:true,alertText:'נא למלא את כל הטפס',isErrorAlert:true})
          return;
      }
        this.setState({loading:true})
      HttpRequest('clients',"POST",{client:c}).then((res)=>{
          this.setState({showAlert:true,alertText:'פעולה בוצעה בהצלחה',isErrorAlert:false})
          let clinet=res.data;
          let clients=this.state.clients;
          clients.push(clinet);
          this.setState({clients:clients})
          //Alert.alert(JSON.stringify(res.data))
      }).catch(e=>{
          this.setState({showAlert:true,alertText:'שגיאת רשת,אנא נסה שוב',isErrorAlert:true})
      }).finally(()=>this.setState({loading:false}))
    }
    getData(){
        if(this.state.isSearching){
            if(this.state.filterName=='' && this.state.filterAddress=='')
                return this.state.clients;
            if(this.state.filterName!='' && this.state.filterAddress==''){
                let c=this.state.clients.filter(c=>c.businessName.startsWith(this.state.filterName));
                return c;
            }
            if(this.state.filterName=='' && this.state.filterAddress!='')
                return this.state.clients.filter(c=>c.address.startsWith(this.state.filterAddress))
            if(this.state.filterName!='' && this.state.filterAddress!='')
                return this.state.clients.filter(c=>c.address.startsWith(this.state.filterAddress)  || c.businessName.startsWith(this.state.filterName))
        }

        return this.state.clients;
    }
    showClientOrdersPrintModal(c:IClient){
        this.setState({showPrintModal:true,selectedClient:c})
    }
    render() {
        const data:any[]=[
            {name:'מוהנד עבד אלהדאי',address:'דיזינגוף 31, תל-אביב',phone:'052-1234567',businessNumber:'205537772',contactName:'מוהנד עבד אלהדאי',subClients:[
                    {name:'חורי ניזאר',address:'טייבה',phone:'052-1234567'},{name:'סמי ניזאר',address:'טייבה',phone:'052-1234567'},{name:'רמי ניזאר',address:'טייבה',phone:'052-1234567'}
                ]},
            {name:'אלי ישראלי',address:'דיזינגוף 31, תל-אביב',phone:'052-1234567'}, {name:'אלי ישראלי',address:'דיזינגוף 31, תל-אביב',phone:'052-1234567'}

        ]
        return(
            <KeyboardAvoidingView behavior={Platform.OS == "ios" ? "padding" : "height"} style={{width:'100%',flex:1,backgroundColor:'white'}}>
                <ScrollView keyboardShouldPersistTaps="handled" refreshControl={<RefreshControl refreshing={this.state.fetching} onRefresh={()=>this.fetchData()} />} style={{display:'flex',backgroundColor:'white',flex:1,width:'100%',marginBottom:50}}>
                    <TouchableOpacity style={{height:35,width:'100%',flexDirection:'row',backgroundColor:'#F6F6F6',alignItems:'center',paddingLeft:25}} onPress={()=>this.setState({isAddOpened:!this.state.isAddOpened})} >
                        <View style={{backgroundColor:'#019FB2',width:25,height:25,borderRadius:25,justifyContent:'center',alignItems:'center'}}>
                            <AppText style={{color:'#fff',fontSize:22,lineHeight:30,fontWeight:"700"}}>{this.state.isAddOpened?"-":"+"}</AppText>
                        </View>
                        <AppText style={{color:'#3A3A3A',fontSize:18,lineHeight:30,marginLeft:10,fontWeight:'500'}}>הוספת לקוח</AppText>
                    </TouchableOpacity>
                    <HideableView hidden={!this.state.isAddOpened} style={{width:'100%',backgroundColor:'#F6F6F6'}}>
                        <View style={{flexDirection:'row',justifyContent:'center',marginTop:10}}>
                            <TextInput  placeholderTextColor={'#989898'} onChangeText={(text:string)=>this.setClientProp(text,"businessName")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'שם העסק'}/>
                            <TextInput placeholderTextColor={'#989898'} keyboardType={'numeric'} onChangeText={(text:string)=>this.setClientProp(text,"businessNumber")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'ח.פ'}/>
                        </View>
                        <View style={{flexDirection:'row',justifyContent:'center',marginTop:10}}>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text:string)=>this.setClientProp(text,"contactName")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'איש קשר'}/>
                            <TextInput placeholderTextColor={'#989898'} onChangeText={(text:string)=>this.setClientProp(text,"address")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'כתובת'}/>
                        </View>
                        <View style={{flexDirection:'row',justifyContent:'center',marginTop:10}}>
                            <TextInput placeholderTextColor={'#989898'} keyboardType={'numeric'} onChangeText={(text:string)=>this.setClientProp(text,"phone")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'טלפון'}/>
                            <TextInput placeholderTextColor={'#989898'} keyboardType={'numeric'} onChangeText={(text:string)=>this.setClientProp(text,"email")} style={{height:25,paddingTop:1,paddingBottom:1,width:'40%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'מייל'}/>
                        </View>
                        <View style={{flexDirection:'row',justifyContent:'center',marginTop:10,marginBottom:10}}>
                            <AppButton text={'הוסף'} onPress={()=>this.addClient()} width={70} height={30} isLoading={this.state.loading}/>
                        </View>

                    </HideableView>
                    <View style={{height:35,width:'100%',flexDirection:'row',backgroundColor:'white',alignItems:'center',paddingLeft:10}}>
                        <AppText style={{color:'#3A3A3A',fontSize:18,lineHeight:30,marginLeft:10,fontWeight:'500'}}> סנן</AppText>
                        <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>this.setState({filterName:text})} style={{height:25,paddingTop:1,paddingBottom:1,width:'30%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'שם'}/>
                        <TextInput placeholderTextColor={'#989898'}  onChangeText={(text)=>this.setState({filterAddress:text})} style={{height:25,width:'30%',paddingTop:1,paddingBottom:1,backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,marginLeft:10,textAlign:'right',paddingLeft:10,paddingRight:10}} placeholder={'כתובת'}/>
                        <TouchableOpacity onPress={()=>this.setState({isSearching:!this.state.isSearching})} style={{width:55,height:22,backgroundColor:'#019FB2',marginLeft:10,justifyContent:'center',alignItems:'center',borderRadius:25}}>
                            <AppText style={{color:'#fff',fontWeight:'700'}}>{this.state.isSearching?'ביטול':'חיפוש'}</AppText>
                        </TouchableOpacity>

                    </View>
                    <FlatList
                        style={{flexGrow:1,backgroundColor:'white'}}
                        data={this.getData()}

                        ListHeaderComponent={()=><View style={{height:30,width:'100%',backgroundColor:'#373737',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                            <View style={{flex:0.23,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>שם</AppText>
                            </View>
                            <View style={{flex:0.34,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>כתובת</AppText>
                            </View>
                            <View style={{flex:0.23,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>טלפון</AppText>
                            </View>
                            <View style={{flex:0.2,alignItems:'flex-start'}}>

                            </View>
                        </View>}
                        renderItem={({ item }) =><ClientItem client={item} printCallBack={(c:IClient)=>this.showClientOrdersPrintModal(c)}/> }
                    />
                    <PrintClientOrdersModal client={this.state.selectedClient} show={this.state.showPrintModal} closeCallBack={()=>this.setState({showPrintModal:false})}/>
                    <AlertModal isError={this.state.isErrorAlert} show={this.state.showAlert} text={this.state.alertText} closeCallBack={()=>this.setState({showAlert:false})}/>
                </ScrollView>
            </KeyboardAvoidingView>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {

    };
};

const mapDispatchToProps ={

    saveClients:saveClients
};

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
/*

 */
